import { LetakResponseDataObject } from "@/types/codegen/data-contracts"


export const generateLeafletSlug = (title: string, id: string): string => {
    let slug = title.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, (match, day, month, year) => {
        const d = String(day).padStart(2, '0')
        const m = String(month).padStart(2, '0')
        return `${d}${m}${year}`
    })

    slug = slug
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[đĐ]/g, "d")
        .replace(/[âÂ]/g, "a")
        .replace(/[êÊ]/g, "e")
        .replace(/[.,:"'<>?`!@#$%^&*();/\\]/g, "")
        .replace(/\s+/g, "-")

    slug = slug.replace(/-+/g, '-')
    slug = slug.replace(/^-+|-+$/g, '')

    return `${slug}-${id}`
}

export const calculateStatus = (dateStart?: string, dateEnd?: string): "ongoing" | "upcoming" | "expired" => {
    if (!dateStart || !dateEnd) {
        return "ongoing"
    }

    const now = new Date()
    const start = new Date(dateStart)
    const end = new Date(dateEnd)

    if (now < start) {
        return "upcoming"
    } else if (now > end) {
        return "expired"
    } else {
        return "ongoing"
    }
}

export const getCatalogImageUrls = (leaflet: LetakResponseDataObject): string[] => {
    if (leaflet?.attributes?.catalogImages?.data && leaflet?.attributes?.catalogImages.data.length > 0) {
        const urls = leaflet?.attributes?.catalogImages.data.map((img: any) => {
            const url = img?.attributes?.url || img?.url || img?.attributes?.data?.attributes?.url
            if (!url) {
                console.warn("Image missing URL:", img)
                return ""
            }
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url
            }
            return `${process.env.NEXT_PUBLIC_API_URL || ''}${url}`
        }).filter(Boolean)
        return urls
    }
    return []
}

export const handleDownload = (leaflet: LetakResponseDataObject | null) => {
    if (!leaflet) return

    if (leaflet?.attributes?.pdfFile?.data?.attributes?.url) {
        const link = document.createElement('a')
        link.href = leaflet?.attributes?.pdfFile.data.attributes.url
        link.download = leaflet?.attributes?.pdfFile.data.attributes.name || `${leaflet?.attributes?.title}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    } else {
        if (leaflet?.attributes?.featuredImage) {
            const link = document.createElement('a')
            link.href = leaflet?.attributes?.featuredImage?.data?.attributes?.url as string
            link.download = `${leaflet?.attributes?.title}.jpg`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}

export const handleCopyLink = (
    leaflet: LetakResponseDataObject | null,
    locale: string,
    onSuccess?: () => void,
    onError?: (error: Error) => void
) => {
    if (!leaflet) return

    const url = `${window.location.origin}/${locale}/letak/${leaflet.id}`
    navigator.clipboard.writeText(url).then(() => {
        if (onSuccess) {
            onSuccess()
        }
    }).catch((err) => {
        const error = err instanceof Error ? err : new Error(String(err))
        if (onError) {
            onError(error)
        } else {
            console.error("Failed to copy link", error)
        }
    })
}

